import { useStore } from 'effector-react'
import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { FormValues } from '~/entities/BookingCar/ui/Form/model'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { DrawerComponent, useDrawer } from '~/shared/ui/Drawer'
import { FormProvider, TextInput } from '~/shared/ui/form'
import { PercentIcon, ChevronRightIcon, CloseIcon } from '~/shared/ui/icons'
import {
  $validatedPromoCode,
  checkPromoCodeFx,
  promoCodeRemoved,
} from './model'
import {
  PromoCodeButton,
  DrawerWrapper,
  PercentIconWrapper,
  DrawerTitle,
  ButtonTitle,
  IconButton,
  SubmitButton,
  SuccessMessage,
} from './styled'

type PromoCodeProps = {
  form: UseFormReturn<FormValues>
  driverId?: string
  carId?: string
}

export function PromoCode({ form, driverId, carId }: PromoCodeProps) {
  const [isDrawerShow, openDrawer, closeDrawer] = useDrawer()
  const isLoading = useStore(checkPromoCodeFx.pending)
  const validatedPromoCode = useStore($validatedPromoCode)

  useEffect(() => {
    form.setValue('promocode', validatedPromoCode?.code || null)
  }, [validatedPromoCode, form])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const promoCodeValue = form.getValues('promocode')
    if (promoCodeValue === validatedPromoCode?.code) {
      snackbarEnqueued({
        message:
          'Вы уже вводили этот промокод ранее. Акция для вас уже активирована',
        variant: 'warning',
      })
      return
    }

    if (!promoCodeValue) return

    const result = await checkPromoCodeFx({
      promoCode: promoCodeValue,
      driverId: driverId || '',
      carId: carId || '',
    })
    if (result.valid) {
      closeDrawer()
    }
  }

  const handleRemovePromoCode = (e: React.MouseEvent) => {
    e.stopPropagation()
    promoCodeRemoved()
    openDrawer()
  }

  return (
    <>
      <div>
        <PromoCodeButton onClick={openDrawer}>
          <ButtonTitle>
            <PercentIconWrapper>
              <PercentIcon />
            </PercentIconWrapper>
            {validatedPromoCode ? validatedPromoCode.code : 'Промокод'}
          </ButtonTitle>
          {validatedPromoCode ? (
            <IconButton onClick={handleRemovePromoCode}>
              <CloseIcon />
            </IconButton>
          ) : (
            <ChevronRightIcon />
          )}
        </PromoCodeButton>
        {validatedPromoCode && (
          <SuccessMessage>Промокод успешно применён</SuccessMessage>
        )}
      </div>
      <DrawerComponent isShow={isDrawerShow} onCancel={closeDrawer}>
        <FormProvider form={form}>
          <DrawerWrapper>
            <DrawerTitle>Промокод</DrawerTitle>
            <TextInput name='promocode' label='Ввести промокод' />

            <SubmitButton fullWidth disabled={isLoading} onClick={handleSubmit}>
              {isLoading ? 'Проверка...' : 'Применить'}
            </SubmitButton>
          </DrawerWrapper>
        </FormProvider>
      </DrawerComponent>
    </>
  )
}
